import request from "@utils/request";
import { ParamsProps, ReturnType } from "./types";

const create = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/stores`,
      method: "post",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Created Successfully",
        showErr: true,
        store: {
          key: args?.state,
          action: "prepend",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const update = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/stores/${args?.id}`,
      method: "patch",
      authorization: true,
      data: args?.data,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "update",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const remove = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/stores/${args?.id}`,
      method: "delete",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Deleted Successfully",
        showErr: true,
        store: {
          key: args?.state,
          action: "remove",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "users/stores",
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
      },
      cacheTTL: 120000,
    };
    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: "set",
      };
    }
    const response = await request(config);

    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const removeCoverImage = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/stores/cover-images/${args?.id}`,
      method: "delete",
      authorization: true,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "remove",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const removeStoreType = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/stores/types/${args?.id}`,
      method: "delete",
      authorization: true,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "remove",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const removeBanner = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/stores/banners/${args?.id}`,
      method: "delete",
      authorization: true,

      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "remove",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const find = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/stores/${args.id}`,
      method: "get",
      authorization: true,
      config: {
        showErr: args?.showErr ?? true,
        store: {
          key: args?.state,
          action: "set",
        },
      },
      cacheTTL: 120000,
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const login = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "users/login",
      method: "post",
      data: args?.data,
      authorization: false,
      config: {
        showErr: true,
        successMsg: "Login Successfully.",
      },
    };
    const response = await request(config);

    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const logout = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "users/logout",
      method: "post",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Logout Successfully.",
        showErr: true,
        store: {
          key: "user",
          action: "reset",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const checkEmailAndPhone = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "users/stores/check-availability",
      method: "get",
      authorization: false,
      params: args?.params,
      config: {
        showErr: false,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const checkOwnerEmailAndPhone = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "users/check-availability",
      method: "get",
      authorization: false,
      params: args?.params,
      config: {
        showErr: false,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const getGeometries = async () => {
  try {
    const config: ReturnType = {
      url: "users/stores/geometries",
      method: "get",
      authorization: true,
      config: {
        showErr: true,
      },
      cacheTTL: 120000,
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const getStoreAnalytics = async (storeId?: number) => {
  try {
    const config: ReturnType = {
      url: "stores/analytics",
      method: "get",
      authorization: true,
      params: storeId ? { storeId } : {},
      config: {
        showErr: false,
      },
      cacheTTL: 120000,
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

export default {
  list,
  create,
  update,
  remove,
  removeCoverImage,
  removeBanner,
  login,
  logout,
  find,
  checkEmailAndPhone,
  checkOwnerEmailAndPhone,
  getGeometries,
  removeStoreType,
  getStoreAnalytics,
};
